import {nextTick} from 'vue'
import {create_store, downloadFile} from 'stores/files'


import * as $utils from 'utils';
export default {
  props: {
    maxUploads: {
      type: Number,
      default: undefined,
    },
    maxSize: {
      type: Number,
      default: undefined,
      required: true
    },
    accept: {
      type: String,
      required: true,
      default: ''
    },
    storeType: {
      type: String,
      default: undefined,
      required: true
    },
    storeTag: { 
      type: String,
      default: undefined,
      required: true
    },
    txtRows: {
      type: Number,
      default: 5
    },
    fileRows: {
      type: Number,
      default: 4
    }
  },
  emits: ['uploaded', 'removed'],
  data() {
    console.log('create store: ', this.storeTag)
    return {
      active: false,
      error: false,
      files_height: 'max-content',
      uploads_height: 'max-content',
      store: create_store(this.storeType, this.storeTag || '00000000-0000-0000-0000-000000000000')
    }
  },
  computed: {
    allowed_types_text() {
      return $utils.str.join(this.accept.split(',').map(ext => ext.substring(1)), {uppercase: true})
    },
    can_upload(){
      if (this.store.loading) return false
      return this.maxUploads ? this.store.total < this.maxUploads : true
    },
    uploads(){
      return this.store.uploads
    },
    files() {
      return this.store.files
    },
    uploading(){
      return this.store.uploads.some(x => x.active)
    }
  },
  watch: {
    storeTag() {
      this.store = create_store(this.storeType, this.storeTag)
    },
    fileRows(){
      this.onFilesResize()
    }
  },
  beforeMount() {
    // TODO: Show progress while store is loading?
    //       Ensure that progress is displayed in
    //       the way that doesn't move other controls
    this.store.load()
  },
  methods: {
    dragover(event) {
      this.active = true
    },
    dragleave(event) {
      if (event.currentTarget.contains(event.relatedTarget)) return
      this.active = false
    },
    drop(event) {
      try {
        if (event.dataTransfer.files.length === 0) return    
        this.$refs.file.files = event.dataTransfer.files
        this.onDrop()
      }
      finally {
        this.active = false
      }
    },
    onDrop() {
      const files = Array.from(this.$refs.file.files)
      this.store.upload(files[0], {
        resolve: (result) => this.$emit('uploaded', result)
      })
    },
    onFileInput(){
      this.error = false 
      this.$refs.file.value = null 
    },
    async onRemove(file_id) {
      await this.store.delete(file_id)
      this.$emit('removed', file_id)
    },
    onDownload(file_id) {
      downloadFile(file_id)
    },
    onUploadsResize(){
      nextTick(() => {
        this.$refs.uploads_scroll?.scrollTop(65535)
      })

      const uploads = this.$refs.uploads
      if (!uploads || uploads.length <= this.fileRows) {
        this.uploads_height = 'max-content'
        return
      }

      const segment = uploads[0].$el
      const count = Math.min(this.fileRows, uploads.length)
      this.uploads_height = `${segment.getBoundingClientRect().height * count + count-1}px`
    },
    onFilesResize(){
      nextTick(() => {
        this.$refs.files_scroll?.scrollTop(0)
      })

      const files = this.$refs.files
      if (!files || files.length <= this.fileRows) {
        this.files_height = 'max-content'
        return
      }

      const segment = files[0].$el
      const count = Math.min(this.fileRows, files.length)
      this.files_height = `${segment.getBoundingClientRect().height * count + count-1}px`
    },
  }
}